import React from 'react'

import cn from 'classnames'
import s from './TextBox.scss'

export default props => {
  const { children, className, ...otherProps } = props
  return (
    <div className={cn(s.textBox, className)} {...otherProps}>
      {children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Text/TextBox/TextBox.jsx